import LanguageSelectorWrapper from '../LanguageSelectorWrapper'
import { ContextApp } from '@monorepo/service'
import { classNames, useMediaQuery } from '@monorepo/utils'
import { useLogin } from '@monorepo/api'
import styles from './styles.module.css'
import { useContext } from 'react'
import { getCommonAssetPath } from '../../geo/config'
import { useTranslation } from 'react-i18next'
import { LANDING_TYPE } from '../../constants'

const Header = () => {
  const { isCdaBalancerInfoLoading, cdaBalancerInfo } = useContext(ContextApp)
  const logoMobileSrc = getCommonAssetPath('logoMobile.svg')
  const logoTabletSrc = getCommonAssetPath('logoTablet.svg')
  const logoDesktopSrc = getCommonAssetPath('logoDesktop.svg')
  const logoProviderSrc = getCommonAssetPath('logoProvider.webp')
  const {isMobile} = useMediaQuery()
  const { origin, redirectToLoginPage } = useLogin({
    isBalancerInfoLoading: isCdaBalancerInfoLoading,
    balancerInfo: cdaBalancerInfo,
    landingType: LANDING_TYPE,
  })
  const { t } = useTranslation()

  const handleLoginClick = () => {
    redirectToLoginPage('header')
  }
  return (
    <div className={styles.header}>
      <div className={styles.navInner}>
        <div className={styles.navlogo}>
          <picture>
            <source srcSet={logoDesktopSrc} media="(min-width: 1200px)" />
            <source srcSet={logoTabletSrc} media="(min-width: 768px)" />
            <img src={logoMobileSrc} alt="BoostWin" />
          </picture>
            {!isMobile && <img src={logoProviderSrc} alt="logo provider" className={styles.logoProvider} />}
        </div>
        <div className={styles.navRight}>
          <div className={styles.navBtn}>
            <a
              className={classNames(styles.button, isCdaBalancerInfoLoading && styles.loading)}
              data-cy="login-button"
              data-origin={origin}
              onClick={handleLoginClick}
            >
              {t('global.login', 'Войти')}
            </a>
          </div>
          <LanguageSelectorWrapper />
        </div>
      </div>
    </div>
  )
}

export default Header
